import GridBlock from "components/GridBlock";
import Tr from "translations/Translations";
import React, {useState} from "react";
import PropTypes from "prop-types";
import {TextField, withStyles} from "@material-ui/core";

const style = theme => ({
    root: {
        marginBottom: theme.spacing(2),
        marginLeft: theme.spacing(1),

        '&>*:not(:first-child)': {
            marginLeft: theme.spacing(4),
        }
    },
    search: {
        width: 300
    },
    chipsGrid: {
        marginTop: theme.spacing(1)
    }
})

function AuditAllowedObjectListSearchBar({
        classes,
        setFilters,
        filters,
        adminMode
    }) {

    const [value, setValue] = useState({number: '', name: '', owner: ''});

    const handleKeyUp = (e) => {
        if (e.key === 'Enter') {
            setFilters(value);
        }
    }

    return (
        <>
            <GridBlock
                alignItems='flex-end'
                className={classes.root}
            >
                <TextField
                    className={classes.search}
                    label={Tr('number_of_processing')}
                    onChange={e => setValue({...value, number: e.target.value})}
                    onKeyUp={handleKeyUp}
                    fullWidth

                />
                <TextField
                    className={classes.search}
                    label={Tr('name')}
                    onChange={e => setValue({...value, name: e.target.value})}
                    onKeyUp={handleKeyUp}
                    fullWidth

                />
                <TextField
                    className={classes.search}
                    label={Tr('owner')}
                    onChange={e => setValue({...value, owner: e.target.value})}
                    onKeyUp={handleKeyUp}
                    fullWidth

                />
            </GridBlock>
        </>
    )
}

AuditAllowedObjectListSearchBar.propTypes = {
    classes: PropTypes.any,
}

AuditAllowedObjectListSearchBar.defaultProps = {}

export default withStyles(style)(AuditAllowedObjectListSearchBar);